import { AxiosRequestConfig } from "axios";
import ApiBase from "../apiRequestBase";
import { NicePostRequest } from "../../models/communityTalk/nicePostRequest";

/**
 * いいね周りのAPIへのリクエスト。
 */
export default class NiceApiRequest {
	/**
	 * replyNiceのPOSTリクエスト
	 */
	public async postNice(tenantId: string, request: NicePostRequest): Promise<string> {
		// リクエストの設定
		// params,headers等の設定もここで行う
		const options: AxiosRequestConfig = {
			url: `${process.env.VUE_APP_API_ENDPOINT}/nice`,
			method: "POST",
			headers: {
				tenantId: tenantId,
			},
			data: request,
		};

		return (await ApiBase.requestWithApiToken<string>(tenantId, options)) as string;
	}
}
